/**
 * Flow/Bundle notifications where the actor liked or commented — avatar should open their profile, not the content.
 */
export function isLikeOrCommentFlowBundleNotification(
  notification: any
): boolean {
  if (!notification) {
    return false;
  }
  const ct = (
    notification.ContentType ||
    notification.contentType ||
    ""
  )
    .toString()
    .trim();
  if (ct !== "Flow" && ct !== "Bundle") {
    return false;
  }
  const raw = (
    notification.Message ||
    notification.message ||
    ""
  ).toString();
  const firstLine = raw.split("\n")[0] || "";
  const title = firstLine.replace(/<[^>]*>/g, "").trim();
  if (title === "New Like On Content" || title === "New Comment On Content") {
    return true;
  }
  const flat = raw.replace(/<[^>]*>/g, " ");
  return (
    /\bhas\s+liked\s+your\s+(flow|bundle)\b/i.test(flat) ||
    /\bhas\s+commented\s+on\s+your\s+(flow|bundle)\b/i.test(flat) ||
    /\bcommented\s+on\s+your\s+(flow|bundle)\b/i.test(flat)
  );
}

/**
 * Avatar should open profile (not content) for these notification types.
 */
export function shouldAvatarOpenProfile(notification: any): boolean {
  if (!notification) {
    return false;
  }
  const ct = (
    notification.ContentType ||
    notification.contentType ||
    ""
  )
    .toString()
    .trim();
  if (ct === "Consult") {
    return true;
  }
  if (ct === "User Following") {
    return true;
  }
  if (ct === "Collaboration") {
    return true;
  }
  return isLikeOrCommentFlowBundleNotification(notification);
}
